<template>
  <div v-show="isLoading || showInfiniteLoading" id="overlay">
    <div id="loading" class="d-flex justify-content-center align-items-center">
      <div id="loop" :class="{ hide: !isLoading }"></div>
      <div
        id="infinity"
        class="justify-content-center align-items-center d-md-flex d-none"
        :class="{
          hide: !showInfiniteLoading,
          enlarge: enlargeActive,
        }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-200 -100 900 410"
          id="infsvg"
        >
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path
                class="cls-1"
                d="M250,116.37c-10,10-43,42.62-57.24,56.86-28.18,28.18-49.07,37.52-76.35,37.52a94.38,94.38,0,0,1,0-188.75c27.28,0,48.17,9.34,76.35,37.52C207,73.75,240,106.41,250,116.37S293,159,307.2,173.23c28.18,28.18,49.06,37.52,76.34,37.52a94.38,94.38,0,0,0,0-188.75c-27.28,0-48.16,9.34-76.34,37.52C293,73.75,259.92,106.41,250,116.37"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
  <Header></Header>
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
  <FooterEn v-if="this.$route.name === 'AboutEn'"></FooterEn>
  <Footer v-else></Footer>
</template>

<script>
// import store from '@/store';

import Header from '@/components/global/Header.vue';
import GroupTab from '@/components/global/GroupTab.vue';
import Footer from '@/components/global/Footer.vue';
import FooterEn from '@/components/global/FooterEn.vue';
import lottie from 'lottie-web';

import loading from '@/assets/js/loop_animation.json';
// import infinity from '@/assets/img/loop.svg';

export default {
  components: {
    Header,
    GroupTab,
    Footer,
    FooterEn,
  },
  data() {
    return {
      // showOverlay: true,
      // isLoading: true,
      enlargeActive: false,
      // infinity,
    };
  },
  mounted() {
    // const inf = document.querySelectorAll('.cls-1')[0];
    lottie.loadAnimation({
      container: document.getElementById('loop'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loading,
    });
    // setTimeout(() => {
    //   lottie.stop();
    //   this.isLoading = false;
    // }, 2000);
    // setTimeout(() => {
    //   this.enlargeActive = true;
    //   inf.classList.add('broaden');
    // }, 2100);
    // setTimeout(() => {
    //   document.getElementById('overlay').classList.add('fade-exit');
    // }, 2400);
    // setTimeout(() => { this.showOverlay = false; }, 2700);
  },
  computed: {
    isLoading() {
      return this.$store.getters.getLoadingState;
    },
    showInfiniteLoading() {
      return this.$store.getters.getInfiniteLoading;
    },
    key() {
      return this.$route.path;
    },
  },
  watch: {
    // isLoading(newValue, oldValue) {
    //   if (oldValue === true && newValue === false) {
    //     setTimeout(() => {
    //       const inf = document.querySelector('.cls-1');

    //       this.enlargeActive = true;
    //       inf.classList.add('broaden');
    //     }, 500);
    //     setTimeout(() => {
    //       document.getElementById('overlay').classList.add('fade-exit');
    //     }, 700);
    //   }
    // },
    showInfiniteLoading(newValue, oldValue) {
      if (oldValue === false && newValue === true) {
        // lottie.stop();
        const inf = document.querySelector('.cls-1');

        setTimeout(() => {
          this.enlargeActive = true;
          inf.classList.add('broaden');
        }, 0);
        setTimeout(() => {
          document.getElementById('overlay').classList.add('fade-exit');
        }, 0);

        setTimeout(() => {
          this.$store.commit('setInfiniteLoading', { status: false });

          this.enlargeActive = false;
          document.getElementById('overlay').classList.remove('fade-exit');
          inf.classList.remove('broaden');
        }, 700);
      }
    },
  },
};
</script>

<style lang="stylus">
#loading
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 10000;
  background-color: #000;

#overlay
  opacity: 1;
  z-index: 999;
  position: relative;
  transition: opacity 0.3s linear;

  &.fade-exit
    opacity: 0;

  #loop
    width: 33%;

#loop, #infinity
  &.hide
    z-index: -100;
    display: none !important;

#infinity
  display: flex;
  transition: all 0.3s linear;
  width: 100%;
  height: 40%;

  svg
    width: 20%;
    transition: width 0.5s linear;

  .cls-1
    fill: none;
    stroke: #73a09c;
    stroke-miterlimit: 10;
    stroke-width: 60px;
    transition: stroke-width 0.6s linear;
    stroke-opacity: 0.7;

#infinity.enlarge
  width: 100%;
  height: 100%;

  svg
    width: 100%;
    height: 100%;

  .cls-1.broaden
    stroke-width: 50vh;
</style>

<style lang="stylus">
@font-face
  font-family: 'GT America';
  font-weight: lighter;
  font-style: normal;
  src: local('GT America'), url('assets/fonts/GT-America-Light.otf') format('opentype');

@font-face
  font-family: 'GT America';
  src: local('GT America'), url('assets/fonts/GT-America-Medium.otf') format('opentype');
  font-weight: medium;
  font-style: normal;

html, body
  height: 100vh;
  font-size: 15px;

body
  overflow-y: scroll;

#app
  position: relative;
  min-height: 100vh;
  font-family: 'Noto Sans SC', sans-serif;
  font-style: normal;
  font-weight: 400;
  color: $monoc4;
  background-color: $monoc1;
  padding-bottom: 135px;

.title
  font-size: 1.5rem; // 18px
  font-weight: 700;
  line-height: 26px;

.title-en
  font-size: 1.1rem; // 16px
  font-weight: 700;
  line-height: 23px;

.text
  font-size: 1rem; // 15px
  font-weight: 400;
  line-height: 24px;

.container-md.page
  padding: 24px;

@media screen and (min-width: 768px)
  .container-md.page:not(.home)
    padding: 48px;
    padding-top: 200px; // for fixed header

.small-text
  font-size: 1rem; // 15px
  line-height: 160%;

.h3-style
  font-size: 1.6rem; // 24px
  font-weight: 700;
  line-height: 29px;

.h2-style
  font-size: 2rem; // 30px
  font-weight: 700;
  line-height: 33px;

.old-h3-bold
  font-size: 1.7rem; // 26px
  font-weight: 700;
  line-height: 28px;

.h4-style
  font-size: 1.33rem; // 20px
  font-weight: 700;
  line-height: 24px;

.old-body
  font-size: 1.2rem; // 18px
  font-weight: 400;
  line-height: 28px;

.old-mini
  font-size: 0.83rem; // 12.5px
  line-height: 18px;

.old-small
  font-size: 1rem; // 15px
  font-weight: 400;
  line-height: 24px;

.old-small-bold
  font-size: 1rem; // 15px
  font-weight: 700;
  line-height: 22px;

@media screen and (max-width: 767.5px)
  html, body, .mobile-body
    font-size: 16px !important;
    line-height: 160% !important;

  .mobile-h1
    font-weight: bold;
    font-size: 30px;
    line-height: 120%;

  .mobile-h2
    font-weight: bold;
    font-size: 26px;
    line-height: 120%;

  .mobile-h3
    font-weight: bold;
    font-size: 20px;
    line-height: 110%;

  .mobile-h4
    font-size: 18px;
    line-height: 110%;

  .mobile-small
    font-size: 14px;
    line-height: 150%;

  .mobile-mini
    font-size: 12px;
    line-height: 100%;

.flex-break
  flex-basis: 100%;
  height: 0;

.flex-center
  display: flex;
  justify-content: center;
  align-items: center;

@media screen and (max-width: 575.5px)
  .n-mx-rem
    margin-left: -1.5rem;
    margin-right: -1.5rem;

// @media screen and (max-width: 1439.5px)
// html, body
// font-size: 14px;

// @media screen and (max-width: 1199.5px)
// html, body
// font-size: 13px;
@media screen and (max-width: 1023.5px)
  #app
    padding-bottom: 192px;

@media screen and (max-width: 991.5px)
  html, body
    font-size: 16px;

@media screen and (max-width: 767.5px)
  #app
    padding-bottom: 300px;

  .container.page
    padding: 24px;
</style>

<style lang="stylus">
// carousel customizations
.h-bar-carousel
  .carousel__prev, .carousel__next
    background-color: $monoc2;
    color: $monoc1;
    bottom: -24px;
    top: initial;

  .carousel__prev
    left: initial;
    right: 30px;

  .carousel__next
    left: initial;
    right: 20px;

  .carousel__slide
    display: block !important;

  .carousel__pagination
    width: 90px;
    padding: 0;
    margin-top: 16px;
    border-radius: 5px;

  .carousel__pagination-item
    flex: 1 1 0%;

  .carousel__pagination-button
    position: relative;
    display: inline-block;
    // margin: 0;
    width: 10px;
    padding: 0;
    height: 10px;
    background-color: $monoc2;
    border-radius: 5px;

    &:after
      content: '';
      border: 1px solid transparent;
      width: 16px;
      height: 16px;
      position: absolute;
      border-radius: 50%;
      top: -3px;
      left: -3px;

  .carousel__pagination-button--active
    background-color: $monoc4;
    // border-radius: 50px;
    z-index: 50;

    &:after
      border-color: $monoc4;

/* fade */
/* fade-transform */
.fade-transform-leave-active, .fade-transform-enter-active
  transition: all 0.4s ease;

.fade-transform-enter-from
  opacity: 0 !important;
  transform: translateX(-30px);

.fade-transform-enter-to
  opacity: 1 !important;

.fade-transform-leave-to
  opacity: 0;
  transform: translateX(30px);
</style>
